import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InfoModal from '../../../shared/components/InfoModal/InfoModal';
import getCommodityValue from '../../../shared/helpers/getCommodityValue';
import CommodityIcon from '../../../shared/components/CommodityIcon/CommodityIcon';
import RebateHeaderIcon from '../../../shared/icons/icon-rebate-modal-header.svg';


// eslint-disable-next-line
const DetailsPrice = function DetailsPriceComponent({ rebates, priceDisplay, uuid }) {
  const {
    onSale,
    hasRebates,
    salesPriceDisplay,
    retailPriceDisplay,
    rebatePriceDisplay,
  } = priceDisplay;

  if (hasRebates) {
    const commodityValue = getCommodityValue();
    const rebateTooltipLabel = commodityValue ? `${commodityValue} ${rebates.label}` : rebates.label;

    return (
      <div className="product-details__pricing">
        <div className="product-details__retail">
          <span
            className={
              classNames('product-detail__retail-price-label', {
                'product-detail__strike': onSale,
              })
            }
          >
            {retailPriceDisplay}
          </span>
          {onSale && (
            <span className="product-details__sale-price">
              &nbsp;
              {salesPriceDisplay}
              &nbsp;
              <span className="product-details__sale">on sale</span>
            </span>
          )}
        </div>
        <div className="product-details__pricing__total">
          <div className="product-details__total product-details__rebate">
            {rebatePriceDisplay}
          </div>
          <div className="marketplace-tooltip__header">
            <CommodityIcon
              className="price-display__commodity-icon"
              commodityValue={commodityValue}
            />
            {'Your price after '}
            <InfoModal
              styleFlag="rebate"
              message={rebates.tooltip}
              contentLabel="Instant Rebates"
              subheader="You may be eligible for"
              header="Instant rebates!"
              headerIcon={<RebateHeaderIcon />}
            >
              <span>{rebateTooltipLabel}</span>
            </InfoModal>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="product-details__pricing">
      {onSale && (
        <h3 className="product-details__retail">
          <span className="product-detail__retail-price-label product-detail__strike">
            {retailPriceDisplay}
          </span>
        </h3>
      )}
      <div className="product-details__pricing__total">
        <h2 className="product-details__total">
          {salesPriceDisplay}
          {onSale && <span className="product-details__sale"> on sale</span>}
        </h2>
      </div>
    </div>
  );
};

DetailsPrice.propTypes = {
  rebates: PropTypes.shape({
    min: PropTypes.shape({
      value: PropTypes.number.isRequired,
      formatted: PropTypes.string,
    }),
    max: PropTypes.shape({
      value: PropTypes.number.isRequired,
      formatted: PropTypes.string,
    }),
    label: PropTypes.string,
    tooltip: PropTypes.string,
  }).isRequired,
  priceDisplay: PropTypes.shape({}).isRequired,
  uuid: PropTypes.string.isRequired,
};

export default DetailsPrice;
